/**
 * SME Portal Layout — wraps all SME portal pages with nav sidebar.
 */
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Toolbar } from '@mui/material';
import PortalNav, { DRAWER_WIDTH, DRAWER_COLLAPSED_WIDTH } from '../shared/PortalNav';

interface SMELayoutProps {
  userRole?: string | null;
  roleDisplayName?: string | null;
}

const SMELayout: React.FC<SMELayoutProps> = ({ userRole, roleDisplayName }) => {
  const [collapsed, setCollapsed] = useState(false);
  const sidebarWidth = collapsed ? DRAWER_COLLAPSED_WIDTH : DRAWER_WIDTH;

  return (
    <Box sx={{ display: 'flex' }}>
      <PortalNav portal="sme" roleDisplayName={roleDisplayName} collapsed={collapsed} onToggleCollapse={() => setCollapsed((c) => !c)} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${sidebarWidth}px)` },
          transition: 'width 0.2s ease',
          minHeight: '100vh',
          background: 'linear-gradient(135deg, rgba(72,54,152,0.05) 0%, rgba(0,51,141,0.04) 35%, rgba(0,94,184,0.05) 65%, rgba(72,54,152,0.03) 100%)',
        }}
      >
        <Toolbar />
        <Outlet context={{ userRole, roleDisplayName }} />
      </Box>
    </Box>
  );
};

export default SMELayout;
